import create, { GetState, SetState } from 'zustand'
import moment from 'moment'
import { handleAxiosError } from '../utils/error'
import { Axios } from '../utils/axios'

type DashboardState = {
  loading: string
  quotes?: any
  dashboardLoading?: string
  policies?: any
  getQuotes: (page?: number) => void
  getStats: () => void
  getPolicies: () => void
  getDashboardData: () => void
  quotePageInfo: any
  policyPageInfo: any
  expiry: any
  expired: any
}

const defaultState = {
  loading: 'idle',
  quotes: []
}

const DashboardStore = (set: SetState<DashboardState>, get: GetState<DashboardState>) => ({
  ...defaultState,
  getQuotes: async (page = 1) => {
    const { quotes } = get()
    let status = 'loading'
    if (quotes?.length > 0) {
      status = 'updating'
    }
    set({ loading: status })
    try {
      const { data } = await Axios.get(`/policy?payment_status=0&page=${page}&limit=1000`)
      set({
        quotes: data.data.policies,
        loading: 'success',
        quotePageInfo: data.data.page_info
      })
    } catch (error: any) {
      set({ loading: 'success' })
      handleAxiosError(error)
    }
  },
  getStats: async () => {
    const { quotes } = get()
    let status = 'loading'
    if (quotes?.length > 0) {
      status = 'updating'
    }
    set({ loading: status })
    try {
      const { data } = await Axios.get(
        'policy?limit=1000&sort_dir=DESC&sort_by=expiration_date&payment_status=1&expire=7 DAY'
      )

      const { data: expireddata } = await Axios.get(
        `policy?limit=10&sort_dir=DESC&sort_by=expiration_date&payment_status=1&expired=true`
      )

      set({ expiry: data.data, expired: expireddata?.data.policies.length, loading: 'success' })
    } catch (error: any) {
      set({ loading: 'success' })
      handleAxiosError(error)
    }
  },
  getPolicies: async () => {
    const { policies } = get()
    let status = 'loading'
    if (policies?.length > 0) {
      status = 'updating'
    }
    set({ loading: status })
    try {
      const { data } = await Axios.get('/policy?payment_status=1&limit=1000')
      set({ policies: data.data.policies, loading: 'success', policyPageInfo: data.data.page_info })
    } catch (error: any) {
      set({ loading: 'error' })
      handleAxiosError(error)
    }
  },
  getDashboardData: async () => {
    const { quotes, policies } = get()
    let status = 'loading'
    if (policies?.length > 0 && quotes?.length > 0) {
      status = 'updating'
    }
    set({ dashboardLoading: status })
    const { getQuotes, getPolicies, getStats } = get()
    try {
      await getPolicies()
      await getQuotes()
      await getStats()
      set({ dashboardLoading: 'success' })
    } catch (error: any) {
      set({ dashboardLoading: 'error' })
      handleAxiosError(error)
    }
  }
})

const useDashboardStore = create<DashboardState>(DashboardStore)

export default useDashboardStore
